import { useEffect } from 'react';

//exceptClassName, muốn loại trừ class nào không active thì truyền mảng except vào
export const useClickOutside = (ref, onClick, exceptClassName) => {
  useEffect(() => {
    const listener = (event) => {
      // console.log('className dang click la ', event.target.className);
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      if (typeof event.target.className === 'string') {
        let check = 0;
        exceptClassName.forEach((element) => {
          if (event.target.className.indexOf(element) !== -1) {
            check = 1;
            return;
          }
        });
        // console.log(
        //   'check la',
        //   check,
        //   'event.target.className ',
        //   event.target.className,
        // );
        if (check) return;
      }
      if (typeof event.target.className === 'object') return; //trường hợp click vào nút icon dropdown
      onClick(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, onClick]);
};

export default useClickOutside;
